var map = {
	"./de-DE.json": "6922",
	"./en-US.json": "e0e1",
	"./es-ES.json": "4109",
	"./fr-FR.json": "cfe4",
	"./ko-KR.json": "7692",
	"./pt-BR.json": "03bd",
	"./zh-CN.json": "423e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "741a";